const setCookie = (cookieName, cookieValue) => {
  document.cookie = `${cookieName}=${cookieValue};`;
};
$(document).on('click', '[data-category-message-control]', (event) => {
  const categoryControlBTN = $(event.target);
  const categoryId = categoryControlBTN.data('category-message-control');
  setCookie(categoryId, 0);
  categoryControlBTN.closest('.flashmessage').hide().remove();
});
